import axios from 'axios'

import {
    Message
} from 'element-ui'
import router from '../router/index'

import store from '@/store'
import domMessage from './messageOnce'
const messageOnce = new domMessage()
import Vue from "vue";
// 创建axios 实例
const service = axios.create({
    // baseURL: "http://192.168.66.60:8009/api/", 
    // baseURL: 'http://192.168.44.65/api/',
    baseURL: window.location.origin + '/api/',
    // baseURL: 'https://chatlibraryin.newacademic.net/api/',
    timeout: 50000, // 请求超时时间
})

service.interceptors.request.use((config) => {
    config.headers.token = store.getCookie("Chat_token")
    if (config.url == 'chatcqu/') {
        if (config.method === 'post') {
            config.data = {
                ...config.data,
                t: Date.parse(new Date())
            }
        } else if (config.method === 'get') {
            config.params = {
                ...config.params,
                t: Date.parse(new Date())
            }
        }
    }

    return config
}, (err) => {
    return Promise.reject(err)
})

service.interceptors.response.use((res) => {
    const response = res.data
    if (response.code == 0) {
        return res
    } else if (res.data.data) {
        return res.data
    } else {
        if(res.config.url == 'pdf/getpdfchuck/'){
            return res
        }
        if (res.data.msg) {
            Message.error({
                message: res.data.msg,
                type: 'error'
            })
        }
        if (res.data.code === 400) {
            store.clearCookie("Chat_token");
            localStorage.clear()
            sessionStorage.clear()
            router.push({
                path: '/'
            })
        }
        return res
    }
}, (err) => {
    console.log('a')
    return Promise.reject(err)
})

export default service